module.exports = __webpack_public_path__ + "img/KO.5193c9e4.webp";